
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

export default function ActivitiesSection() {
  const activities = [
    {
      id: 1,
      title: '每日签到彩蛋',
      description: '连续签到7天，解锁神秘大礼包，每天都有不同的惊喜等着你！',
      image: 'https://readdy.ai/api/search-image?query=daily%20check-in%20reward%20system%20with%20colorful%20gift%20boxes%20and%20calendar%2C%20bright%20cheerful%20colors%2C%20modern%20flat%20design%20style%2C%20purple%20and%20pink%20theme%2C%20digital%20illustration%2C%20high%20quality&width=400&height=300&seq=activity-1&orientation=landscape',
      reward: '积分奖励',
      participants: '12,580',
      status: 'active',
      icon: 'ri-calendar-check-line'
    },
    {
      id: 2,
      title: '幸运转盘',
      description: '每天免费转一次，有机会获得现金红包、优惠券、实物奖品等丰厚奖励！',
      image: 'https://readdy.ai/api/search-image?query=lucky%20wheel%20spin%20game%20with%20colorful%20segments%2C%20golden%20coins%20and%20gift%20boxes%20around%2C%20festive%20atmosphere%2C%20bright%20colors%2C%20game%20UI%20design%2C%20digital%20art%20style&width=400&height=300&seq=activity-2&orientation=landscape',
      reward: '现金红包',
      participants: '8,920',
      status: 'hot',
      icon: 'ri-refresh-line'
    },
    {
      id: 3,
      title: '节日特别活动',
      description: '春节、情人节、中秋节等重要节日，特别定制的限时彩蛋活动，奖品更丰富！',
      image: 'https://readdy.ai/api/search-image?query=festival%20celebration%20with%20fireworks%2C%20lanterns%2C%20gift%20boxes%2C%20festive%20decorations%2C%20warm%20lighting%2C%20traditional%20and%20modern%20elements%20combined%2C%20joyful%20atmosphere&width=400&height=300&seq=activity-3&orientation=landscape',
      reward: '限定礼品',
      participants: '25,670',
      status: 'coming',
      icon: 'ri-fire-line'
    },
    {
      id: 4,
      title: '邀请好友',
      description: '邀请好友注册并完成首次许愿，双方都能获得专属福利，友谊与惊喜双丰收！',
      image: 'https://readdy.ai/api/search-image?query=friends%20sharing%20gifts%20and%20celebrating%20together%2C%20happy%20people%20with%20colorful%20presents%2C%20friendship%20theme%2C%20warm%20colors%2C%20illustration%20style%2C%20positive%20energy&width=400&height=300&seq=activity-4&orientation=landscape',
      reward: '双倍奖励',
      participants: '6,340',
      status: 'active',
      icon: 'ri-user-add-line'
    },
    {
      id: 5,
      title: '许愿达人',
      description: '完成指定数量的许愿任务，解锁达人徽章，享受专属特权和优先福利！',
      image: 'https://readdy.ai/api/search-image?query=achievement%20badges%20and%20trophies%20with%20stars%20and%20ribbons%2C%20golden%20and%20silver%20medals%2C%20success%20celebration%2C%20premium%20design%2C%20luxury%20feel&width=400&height=300&seq=activity-5&orientation=landscape',
      reward: '专属徽章',
      participants: '4,120',
      status: 'active',
      icon: 'ri-medal-line'
    },
    {
      id: 6,
      title: '神秘宝箱',
      description: '随机出现的神秘宝箱，需要完成特定任务才能开启，里面藏着意想不到的惊喜！',
      image: 'https://readdy.ai/api/search-image?query=mysterious%20treasure%20chest%20glowing%20with%20magical%20light%2C%20surrounded%20by%20sparkles%20and%20gems%2C%20fantasy%20style%2C%20dark%20background%20with%20bright%20highlights%2C%20mystical%20atmosphere&width=400&height=300&seq=activity-6&orientation=landscape',
      reward: '神秘奖励',
      participants: '15,890',
      status: 'mystery',
      icon: 'ri-treasure-map-line'
    }
  ];

  const getStatusBadge = (status: string) => {
    const badges = {
      active: { text: '进行中', class: 'bg-green-100 text-green-800' },
      hot: { text: '火热', class: 'bg-red-100 text-red-800' },
      coming: { text: '即将开始', class: 'bg-blue-100 text-blue-800' },
      mystery: { text: '神秘', class: 'bg-purple-100 text-purple-800' }
    };
    const badge = badges[status as keyof typeof badges] || badges.active;
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium ${badge.class}`}>
        {badge.text}
      </span>
    );
  };

  return (
    <section id="activities" className="py-20 bg-gradient-to-b from-purple-50 to-pink-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            <strong>精彩彩蛋活动</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            多样化的互动活动，让每一天都充满惊喜。参与彩蛋活动，赢取丰厚奖励，体验前所未有的乐趣！
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {activities.map((activity) => (
            <Card key={activity.id} hover gradient className="overflow-hidden">
              <div className="relative">
                <img 
                  src={activity.image} 
                  alt={activity.title}
                  className="w-full h-48 object-cover rounded-xl mb-4"
                />
                <div className="absolute top-3 right-3">
                  {getStatusBadge(activity.status)}
                </div>
                <div className="absolute top-3 left-3">
                  <div className="w-10 h-10 bg-white/90 rounded-full flex items-center justify-center">
                    <i className={`${activity.icon} text-purple-600 text-lg`}></i>
                  </div>
                </div>
              </div>

              <div className="space-y-4">
                <h3 className="text-xl font-bold text-gray-800">{activity.title}</h3>
                <p className="text-gray-600 leading-relaxed">{activity.description}</p>
                
                <div className="flex items-center justify-between text-sm text-gray-500">
                  <div className="flex items-center space-x-1">
                    <i className="ri-gift-line text-orange-500"></i>
                    <span>{activity.reward}</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <i className="ri-user-line text-blue-500"></i>
                    <span>{activity.participants}人参与</span>
                  </div>
                </div>

                <Button 
                  variant={activity.status === 'hot' ? 'secondary' : 'primary'} 
                  className="w-full"
                >
                  <i className="ri-play-circle-line mr-2"></i>
                  {activity.status === 'coming' ? '敬请期待' : '立即参与'}
                </Button>
              </div>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <Button size="lg" variant="outline">
            <i className="ri-more-line mr-2"></i>
            查看更多活动
          </Button>
        </div>
      </div>
    </section>
  );
}
